module.exports = __webpack_public_path__ + "static/img/icon_pro5.a828413.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_pro5.png
// module id = weL+
// module chunks = 11